/**
 * Narrows an unknown thrown value to the Rails API's error envelope
 * (`{ response: { data: { errors: string[] } } }`) and joins the messages.
 *
 * Exists because `catch (error)` is typed `unknown` under `strict: true`, and
 * every form page needs the same narrowing to surface server-side validation
 * errors in a StickyActionBar.
 *
 * @param fallback shown when the error does not match the expected envelope.
 */
const extractErrorMessage = (
  error: unknown,
  fallback = "Something went wrong. Please try again.",
): string => {
  if (
    error !== null &&
    typeof error === "object" &&
    "response" in error &&
    error.response !== null &&
    typeof error.response === "object" &&
    "data" in error.response &&
    error.response.data !== null &&
    typeof error.response.data === "object" &&
    "errors" in error.response.data &&
    Array.isArray((error.response.data as { errors: unknown }).errors)
  ) {
    return (error.response.data as { errors: string[] }).errors.join(". ");
  }
  return fallback;
};

export default extractErrorMessage;
